import React, { useEffect, useRef, useState } from "react";
import "./InvestmentSection.css";

export default function InvestmentSection() {
  const sectionRef = useRef(null);
  const imageRef = useRef(null);
  const textRef = useRef(null);

  const [investment, setInvestment] = useState({
    title: "",
    value: "",
    description: "",
    image: ""
  });

  /* ===============================
     FETCH INVESTMENT DATA
  ================================ */
  useEffect(() => {
    fetch("https://pharma.accendiatechnologies.com/batterjee/getvideos.php")
      .then(res => res.json())
      .then(data => {
        if (data.status === "success" && data.investment) {
          setInvestment({
            title: data.investment.title || "",
            value: data.investment.value || "",
            description: data.investment.description || "",
            image: data.investment.image || ""
          });
        }
      })
      .catch(() => {});
  }, []);

  /* ===============================
     SCROLL ANIMATION
  ================================ */
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;

      const rect = sectionRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const distanceFromCenter = Math.abs(
        rect.top + rect.height / 2 - windowHeight / 2
      );
      const maxDistance = windowHeight / 2;
      const progress = Math.max(
        0,
        Math.min(1, 1 - distanceFromCenter / maxDistance)
      );

      const MAX_OFFSET = 40;
      const offset = (1 - progress) * MAX_OFFSET;

      if (imageRef.current && textRef.current) {
        imageRef.current.style.transform = `translateX(${-offset}px)`;
        textRef.current.style.transform = `translateX(${offset}px)`;
        imageRef.current.style.opacity = `${0.5 + progress * 0.5}`;
        textRef.current.style.opacity = `${0.5 + progress * 0.5}`;
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /* ===============================
     VALUE PARSING ($514 M etc.)
  ================================ */
const match = investment.value.match(/([€£$]?)(\d+)\s*(M|B)?/i) || [];
const currency = match[1] || "";
const amount = match[2] || "";
const suffix = match[3] || "";


  return (
    <section ref={sectionRef} className="investment-section">
      <div className="investment-inner">

        {/* IMAGE */}
        <div ref={imageRef} className="investment-image">
          {investment.image && (
            <img src={investment.image} alt="Investment in R&D" />
          )}
          <h2 dangerouslySetInnerHTML={{ __html: investment.title }} />
        </div>

        {/* TEXT */}
        <div ref={textRef} className="investment-text">
          <div className="amount">
            <span className="currency">{currency}</span>
            <span className="value">{amount}</span>
            <span className="suffix">{suffix}</span>
          </div>

          <div
            dangerouslySetInnerHTML={{ __html: investment.description }}
          />
        </div>

      </div>
    </section>
  );
}
